var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.12 2H16.88C7.73333 2 2 8.47383 2 17.6384V42.3616C2 51.5262 7.70667 58 16.88 58H43.12C52.2933 58 58 51.5262 58 42.3616V17.6384C58 8.47383 52.2933 2 43.12 2Z",
    fill: "#28FF81",
    fillOpacity: 0.9,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2051_2357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.752 30.8316L23.554 44.9636C23.4034 45.0639 23.2285 45.1213 23.0478 45.13C22.8671 45.1386 22.6875 45.0981 22.528 45.0127C22.3685 44.9274 22.2352 44.8003 22.1422 44.6452C22.0492 44.49 22.0001 44.3125 22 44.1316V15.8676C22.0001 15.6868 22.0492 15.5093 22.1422 15.3541C22.2352 15.199 22.3685 15.0719 22.528 14.9866C22.6875 14.9012 22.8671 14.8607 23.0478 14.8693C23.2285 14.8779 23.4034 14.9354 23.554 15.0356L44.752 29.1676C44.889 29.259 45.0013 29.3827 45.0789 29.5278C45.1566 29.673 45.1972 29.835 45.1972 29.9996C45.1972 30.1643 45.1566 30.3263 45.0789 30.4715C45.0013 30.6166 44.889 30.7403 44.752 30.8316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2051_2357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9f93d3670cef6707a00a3159f2456abe.svg";
export { ForwardRef as ReactComponent };